import React, { useState, useEffect, useMemo } from 'react';
import { Fab, Dialog, Box, Typography, Grid } from '@mui/material';
import '../../App.css';
import {
  RESET_DATE_RANGE,
  SHOW_NOTIFICATION,
  TimesheetsComponentLoaderAttribute,
  WFHAttribute,
} from '../../constants.js';
import PaginationComponent from '../../components/Pagination/Pagination';
import AddIcon from '@mui/icons-material/Add';
import { SET_DATE_RANGE } from '../../constants.js';
import {
  getReportingManagerForLeave,
  getUserData,
  getUserLeaves,
  getUserManagers,
  getUserProjects,
  getUserWfhSummary,
} from '../../services/UserService';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import './WFHStatusComponent.css';
import WFHSummaryCard from './WFHSummaryCardComponent';
import KeycloakService from '../../services/KeycloakService';
import { getUserWFH, getWFHTask } from '../../services/WFHService';

import {
  resetFilterDataState,
  setFilterConfig,
  setFilterDataState,
} from '../../modules/filter/filterAction';
import {
  cardComponentCollapse,
  cardComponentExpand,
} from '../../modules/cardState/cardAction';
import { MAIN_BLUE } from '../../color';
import GenericLoader from '../../components/Loader/GenericLoader';
import { checkFilterIconVisibility } from '../../components/GenericFilter/FilterIconVisibilityCheck';
import GenericFilterDrawer from '../../components/GenericFilter/GenericFilterDrawer';
import { NO_LEAVE_SUMMARY } from '../Leaves/LeavesConstants';
import WFHStatusCardComponent from './WFHStatusCardComponent';
import { NO_WFH, YYYY_MM_DD } from './TaskConstants';

import ApplyWFHFields from './WFHfields';
import { ADMIN_PATH } from '../../url.js';
import HttpService from '../../services/HttpService.js';
import { getHolidays } from '../../admin/Services/MasterdataService.js';
import { getEmployeeWfhQuota } from '../../admin/Services/EmployeePrivilegesService.js';
import { getSummary } from '../../services/TimingService.js';
import { msToTime } from '../../utils/TimeConversionFunctions.js';

const MyWfhComponent = () => {
  const [pageSize, setPageSize] = useState(5);
  const [loader, setLoader] = React.useState(true);
  const [totalPage, setTotalPage] = React.useState();
  const [pageNo, setPageNo] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [open, setOpen] = React.useState(false);
  const [editableWFH, seteditableWFH] = React.useState({});
  const [editable, setEditable] = React.useState(false);
  const [recipients, setRecipients] = React.useState([]);
  const [managers, setManagers] = React.useState([]);
  const [tasksData, setTasksData] = React.useState([]);
  const currentUserId = KeycloakService.getUserDetail();
  const dispatch = useDispatch();
  const [showError, setShowError] = useState(false);
  const [previousWFH, setpreviousWFH] = React.useState([]);
  const [refresh, setRefresh] = React.useState(true);
  const [resetFilter, setResetFilter] = useState(false);
  const [month, setMonth] = useState('');
  const [year, setYear] = useState(new Date().getFullYear());
  const [monthlyQuotaAlloted, setMonthlyQuotaAlloted] = useState(0);
  const [monthlyQuotaAvailed, setMonthlyQuotaAvailed] = useState(0);
  const [quotaLoader, setQuotaLoader] = useState(true);

  const location = useLocation();
  const xyz = new URLSearchParams(location.search).get('xyz');
  const searchString = window.atob(xyz);
  const leaveStartDate = new URLSearchParams(searchString).get('startDate');
  const leaveEndDate = new URLSearchParams(searchString).get('endDate');
  const tabType = new URLSearchParams(searchString).get('type');

  const [savedStartDate, setSavedStartDate] = React.useState(new Date());
  const [savedEndDate, setSavedEndDate] = React.useState(new Date());
  const dateRangeState = useSelector((state) => state.dateRangeState);
  const [wfhSummary, setWfhSummary] = React.useState([]);

  const filterState = useSelector((state) => state.filterState);
  const emptyFilterData = {
    wfhStatus: '',
    startDate: '',
    endDate: '',
  };

  const _axios = HttpService.getAxiosClient();

  const months = [
    'JANUARY',
    'FEBRUARY',
    'MARCH',
    'APRIL',
    'MAY',
    'JUNE',
    'JULY',
    'AUGUST',
    'SEPTEMBER',
    'OCTOBER',
    'NOVEMBER',
    'DECEMBER',
  ];

  const pageChange = (event, value) => {
    setPageNo(value - 1);
    setPage(value);
    setRefresh(!refresh);
  };
  const [officialHolidays, setOfficialHolidays] = React.useState([]);
  const [leavesList, setLeavesList] = React.useState([]);
  const [pendingOrApprovedLeaves, setPendingOrApprovedLeaves] = useState([]);
  const [canApplyWFH, setCanApplyWFH] = useState(true);
  const getPendingLeaves = async () => {
    const response = await getUserLeaves(currentUserId, { status: 'PENDING' });
    return response?.data?.data?.content;
  };
  const getLeave = async () => {
    const userLeaves = await getUserLeaves(currentUserId, {
      status: 'APPROVED',
    });
    const pendingRes = await getPendingLeaves();
    if (userLeaves?.data?.data?.content?.length && pendingRes)
      setPendingOrApprovedLeaves([
        ...pendingRes,
        ...userLeaves?.data?.data?.content,
      ]);
    if (userLeaves.status !== 200) {
      dipatchNotification(userLeaves.type, userLeaves.message);
    }
    if (userLeaves.isError === false) {
      userLeaves.data.data.content.map((leave) => {
        const startDate = new Date(leave.startDate);
        const endDate = new Date(leave.endDate);
        while (startDate <= endDate) {
          const day = startDate.getDate().toString().padStart(2, '0');
          const month = (startDate.getMonth() + 1).toString().padStart(2, '0');
          const year = startDate.getFullYear().toString();
          setLeavesList((prevDates) => [
            ...prevDates,
            `${day} ${month} ${year}`,
          ]);
          startDate.setDate(startDate.getDate() + 1);
        }
      });
    }
  };

  const getHoliday = async () => {
    const user = await getUserData(currentUserId);
    if (user.data.locationId) {
      const holidayList = await getHolidays(user.data.locationId);
      const arr = [];
      if (holidayList.isError === false) {
        holidayList.data.map((obj) =>
          arr.push(moment(obj.date).format('DD MM YYYY')),
        );
      }
      setOfficialHolidays(arr);
    }
  };

  const handlePageSizeChange = (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    pageChange(null, 1);
    setRefresh(!refresh);
  };

  const getReportingManagers = async () => {
    const reportingManagers = await getUserManagers(currentUserId);
    const user = await getUserData(currentUserId);
    if (reportingManagers.status !== 200) {
      dipatchNotification(reportingManagers.type, reportingManagers.message);
    }
    if (reportingManagers.isError === false) {
      if (
        user.data.employeePrivileges &&
        user.data.employeePrivileges.SELF_APPROVE_LEAVE_WFH === 'YES'
      ) {
        user.data['firstName'] = 'You: ' + user.data['firstName'];
        setManagers([...reportingManagers.data, user.data]);
      } else {
        setManagers(reportingManagers.data);
      }
    }

    if (reportingManagers.data.length === 0) {
      const activeProjects = await getUserProjects(
        currentUserId,
        '',
        '',
        '',
        'ACTIVE',
      );
      if (
        activeProjects.isError === false &&
        activeProjects.data?.content?.length > 0
      ) {
        // User is the sole manager on their active project(s); the request
        // is routed to the senior manager for approval server-side, so show
        // that senior manager as the recipient.
        const seniorManager = await getReportingManagerForLeave(currentUserId);
        if (seniorManager.isError === false && seniorManager.data?.data) {
          setManagers([seniorManager.data.data]);
        }
        setCanApplyWFH(true);
      } else {
        dipatchNotification(
          'error',
          ' WFH cannot be applied as there is no project assigned.',
        );
        setCanApplyWFH(false);
      }
    } else {
      setCanApplyWFH(true);
    }
  };

  const getWFHApplicationList = async () => {
    let userWFHApplications = await getUserWFH(
      currentUserId,
      'WFH',
      pageSize,
      pageNo,
      filterState,
    );
    if (userWFHApplications.status !== 200) {
      dipatchNotification(
        userWFHApplications.type,
        userWFHApplications.message,
      );
    }
    if (userWFHApplications.isError === false) {
      if (userWFHApplications.data.data.numberOfElements == 0) {
        setPageNo(0);
        setPage(1);
      }
      setLoader(false);
      setTotalPage(userWFHApplications.data.data.totalPages);
      setpreviousWFH(
        userWFHApplications.data.data.content.filter(
          (wfh) => wfh.status !== 'CANCELLED',
        ),
      );
      // getWfhSummary(filterState);

      // setLoader(false);
      /**
       * previousWFH -> All WFH Applications (!CANCELLED)
       */
    }
  };

  const getWFHTasks = async () => {
    const employeeId = currentUserId;
    /**
     * It gives All WFH Tasks (PENDING, APPROVED, REJECTED) once the application is Approved.
     * NOTE:- WFHTask and WFHApplication are different.
     */
    const allWFHTasks = await getWFHTask(employeeId);
    if (allWFHTasks.isError === false) {
      setTasksData(allWFHTasks.data.data.content);
    }
  };

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const toggleOpen = () => {
    setTimeout(() => {
      setSavedStartDate(dateRangeState?.startDate);
      setSavedEndDate(dateRangeState?.endDate);
    }, 200);

    dispatch({
      type: RESET_DATE_RANGE,
    });
    setOpen(!open);
    seteditableWFH({});
    setRecipients(() => []);
    setEditable(false);
  };

  const toggleClose = () => {
    dispatch({
      type: SET_DATE_RANGE,
      data: {
        ...dateRangeState,
        startDate: savedStartDate,
        endDate: savedEndDate,
      },
    });
    setOpen(false);
    seteditableWFH({});
    setRecipients(() => []);
    setEditable(false);
  };

  const toggleEditOpen = async (wfh) => {
    seteditableWFH(wfh);

    setEditable(true);
    setOpen(true);
    const arr = wfh.applicationStatusDTOS.map((subject) =>
      getUserData(subject.approverId),
    );
    const list = await Promise.all(arr);
    setRecipients(() => list.map((rec) => rec.data));
  };

  const filterConfiguration = {
    inputField: [
      [
        ['wfhStatus', 'WFH Status'],
        [
          ['APPROVED', 'Approved'],
          ['PENDING', 'Pending'],
          ['REJECTED', 'Rejected'],
          ['TASK_APPROVED', 'Task Approved'],
          ['TASK_PENDING', 'Task Pending'],
        ],
      ],
    ],
  };

  const resetThings = () => {
    dispatch(setFilterConfig(filterConfiguration));
    if (tabType !== 'WFH') {
      dispatch(resetFilterDataState());
      dispatch({
        type: RESET_DATE_RANGE,
      });
      dispatch(cardComponentCollapse());
    } else {
      dispatch(
        setFilterDataState({
          startDate: leaveStartDate,
          endDate: leaveEndDate,
        }),
      );
      dispatch({
        type: SET_DATE_RANGE,
        data: {
          startDate: moment(leaveStartDate).format(YYYY_MM_DD),
          endDate: moment(leaveEndDate).format(YYYY_MM_DD),
          color: MAIN_BLUE,
        },
      });
      dispatch(cardComponentExpand());
    }
  };

  const getQuarterDateRange = (year, quarter) => {
    const ranges = {
      0: [`${year}-01-01`, `${year}-03-31`],
      1: [`${year}-04-01`, `${year}-06-30`],
      2: [`${year}-07-01`, `${year}-09-30`],
      3: [`${year}-10-01`, `${year}-12-31`],
    };
    return ranges[quarter];
  };

  const getWfhSummary = async () => {
    setQuotaLoader(true);
    const year = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const currentQuarterIndex = Math.floor(currentMonth / 3);

    const [quarterStart, quarterEnd] = getQuarterDateRange(
      year,
      currentQuarterIndex,
    );
    const employeeWFHQuota = await getEmployeeWfhQuota(year, currentUserId);
    const summaryData = await getSummary(
      quarterStart,
      quarterEnd,
      currentUserId,
    );

    if (summaryData.isError === false && employeeWFHQuota.isError === false) {
      setMonthlyQuotaAlloted(
        employeeWFHQuota.data.data.quotaWFH.thisYear[currentQuarterIndex],
      );
      setMonthlyQuotaAvailed(summaryData.data.workFromHomeDays);
    }
    setQuotaLoader(false);
  };

  useEffect(() => {
    resetThings();
    setResetFilter(true);
  }, [location]);

  const temp = useMemo(() => {
    pageChange(null, 1);
  }, [filterState]);

  useEffect(() => {
    if (resetFilter) {
      getWFHApplicationList();
      getReportingManagers();
      getWFHTasks();
    }
  }, [refresh, resetFilter]);
  useEffect(() => {
    getHoliday();
    getLeave();
    getWfhSummary();
  }, [refresh]);

  return (
    <div>
      {loader ? (
        <div
          style={{
            height: '80vh',
            overflow: 'hidden',
          }}
        >
          <GenericLoader
            rectAttributes={TimesheetsComponentLoaderAttribute}
            width={'40%'}
            height={150}
          />
          <GenericLoader
            rectAttributes={WFHAttribute}
            showError={showError}
            setShowError={setShowError}
          />
        </div>
      ) : (
        <Box className="main-content-overlay">
          <div className="main-content-div">
            <Fab
              color="primary"
              style={{
                right: 25,
                bottom: 80,
                position: 'fixed',
                zIndex: 1051,
                // the zIndex of edit and delete buttons is 1050
              }}
              onClick={() => {
                if (canApplyWFH) {
                  toggleOpen();
                } else {
                  dipatchNotification(
                    'error',
                    'You cannot apply for WFH without any project.',
                  );
                }
              }}
            >
              <AddIcon />
            </Fab>

            {quotaLoader ? (
              <GenericLoader
                rectAttributes={TimesheetsComponentLoaderAttribute}
                width={'40%'}
                height={150}
              />
            ) : (
              <div className="mt-4">
                <WFHSummaryCard
                  availedHours={`${monthlyQuotaAvailed} days`}
                  allowedHours={
                    // monthlyQuotaAlloted !== 0
                    `${monthlyQuotaAlloted} days`
                    // : msToTime(monthlyQuotaAlloted)
                  }
                  title={'Quarterly WFH Quota'}
                />
              </div>
            )}

            {checkFilterIconVisibility(
              filterState,
              emptyFilterData,
              previousWFH,
            ) && <GenericFilterDrawer />}
            <div>
              {previousWFH.length !== 0 ? (
                previousWFH.map((wfh, index) => {
                  return (
                    <WFHStatusCardComponent
                      pageChange={pageChange}
                      getWFHApplicationList={getWFHApplicationList}
                      key={wfh.id}
                      wfh={wfh}
                      wfhStatus={wfh.status}
                      tasksData={tasksData}
                      setTasksData={setTasksData}
                      toggleEditOpen={toggleEditOpen}
                      refresh={refresh}
                      setRefresh={setRefresh}
                      getWFHTasks={getWFHTasks}
                      officialHolidays={officialHolidays}
                      leavesList={leavesList}
                    />
                  );
                })
              ) : (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '80vh',
                  }}
                >
                  <div>
                    <Typography>{NO_WFH}</Typography>
                  </div>
                </div>
              )}
              <Box className="page-holder" sx={{ marginBottom: '10px' }}>
                {previousWFH.length !== 0 && (
                  <PaginationComponent
                    count={totalPage}
                    page={page}
                    pageChange={pageChange}
                    pageSize={pageSize}
                    handlePageSizeChange={handlePageSizeChange}
                  />
                )}
              </Box>
            </div>

            <Dialog
              open={open}
              onClose={() => toggleClose()}
              fullWidth
              maxWidth="md"
            >
              <ApplyWFHFields
                toggleOpen={toggleClose}
                presetRecipients={managers}
                getWFHApplicationList={getWFHApplicationList}
                editableWFH={editableWFH}
                editable={editable}
                editRecipients={recipients}
                officialHolidays={officialHolidays}
                leavesList={pendingOrApprovedLeaves}
              />
            </Dialog>
          </div>
        </Box>
      )}
    </div>
  );
};

export default MyWfhComponent;
